var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{attrs:{"id":"eu-nav-sidebar"}},[(_vm.theme.layout === 'vertical')?_c('sidebar-vertical'):_c('sidebar-column'),_c('menu-collapse-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }